import URL from "./apiURL";
import api from "../../utils/axiosInstance";

export async function startConversationV2(payload) {
  try {
    const res = await api.post(URL.chatBotStartConversationV2, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function followUpV2(payload) {
  try {
    const res = await api.post(URL.chatBotFollowUpV2, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function feedbackapiV2(payload) {
  try {
    const res = await api.post(URL.chatBotFeedbackV2, payload);
    return res.data;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function getConversationListV2(page, payload) {
  try {
    const res = await api.get(
      `${URL.samarthaiGetConvservationListV2}/get_all_conversations/${payload.user_id}/page/${page}?user_email=${payload.user_email}&user_name=${payload.user_name}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}

export async function renameConversationV2(payload) {
  try {
    const res = await api.post(
      URL.samarthaiRenameConversationTitleV2,
      payload,
    );
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function getFaqV2(payload) {
  try {
    const res = await api.get(
      `${URL.samarthaiGetConvservationListV2}/${payload.user_id}/get_user_faq?user_email=${payload.user_email}&user_name=${payload.user_name}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}

export async function getConversationIdV2(conversationId, page) {
  try {
    const res = await api.get(
      `${URL.samarthaiGetConvservationListV2}/get_messages/${conversationId}/page/${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}

export async function createNewDashboardV2(payload) {
  try {
    const res = await api.post(URL.samarthaiCreateDashboard, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function deleteDashboardV2(payload) {
  try {
    const res = await api.delete(URL.samarthaiDeleteDashboard, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: payload, // request body for DELETE
    });
    return res;
  } catch (error) {
    console.error("Error executing deleteDashboardV2:", error);
    throw error;
  }
}

export async function renameDashboardV2(payload) {
  try {
    const res = await api.post(URL.samarthaiRenameDashboard, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function pinnedPrompt(payload) {
  try {
    const res = await api.post(URL.samarthaiPinned, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function unpinnedPrompt(payload) {
  try {
    const res = await api.put(URL.samarthaiPinned, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}
export async function getPinnedPrompts(payload) {
  try {
    const res = await api.get(
      `${URL.samarthaiGetPinnedPrompts}/get_all_prompt/user/${payload.user_id}?user_name=${payload.user_name}&user_email=${payload.user_email}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}
export async function bookmarked(payload) {
  try {
    const res = await api.post(URL.samarthaiBookmarked, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function unBookmarked(payload) {
  try {
    const res = await api.put(URL.samarthaiBookmarked, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function getBookmarkedPrompts(payload) {
  try {
    const res = await api.get(
      `${URL.samarthaiGetBookmarkedPrompts}/get_bookmarked_list/user/${payload.user_id}?user_name=${payload.user_name}&user_email=${payload.user_email}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}
export async function graphApi(payload) {
  try {
    const res = await api.post(URL.samarthaiGraph, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function getDashboardList(payload) {
  try {
    const res = await api.get(
      `${URL.samarthaiDashboardList}/list/${payload.user_id}?user_name=${payload.user_name}&user_email=${payload.user_email}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}

export async function addDashboardV2(payload) {
  try {
    const res = await api.post(URL.samarthaiAddDashboard, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function getDashboardListById(payload, page) {
  try {
    const res = await api.get(
      `${URL.samarthaiAddDashboardList}/user/${payload.user_id}/dashboard/${payload.dashboard_id}/page/${page}?user_name=${payload.user_name}&user_email=${payload.user_email}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error("Error executing getConversationList:", error);
    throw error;
  }
}

export async function deleteDashboardListV2(payload) {
  try {
    const res = await api.delete(URL.samarthaiDeleteDashboardList, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: payload, // request body for DELETE
    });
    return res;
  } catch (error) {
    console.error("Error executing deleteDashboardV2:", error);
    throw error;
  }
}

export async function dashboardOrderPlacementV2(payload) {
  try {
    const res = await api.post(URL.samarthaiDashboardOrderPlacement, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}

export async function deleteConversation(payload) {
  try {
    const res = await api.delete(URL.samarthaiDeleteConversation, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: payload, // request body for DELETE
    });
    return res;
  } catch (error) {
    console.error("Error executing deleteDashboardV2:", error);
    throw error;
  }
}

export async function dashboardRefresh(payload) {
  try {
    const res = await api.post(URL.samarthaiDashboardRefresh, payload);
    return res;
  } catch (error) {
    console.error("Error executing startConversation:", error);
    throw error;
  }
}